import React, { createContext, useContext, useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import useCollapseGroup from "core/hooks/useCollapseGroup";

const EventRegistrationContext = createContext<any>(null);

type Props = {
    children: React.ReactNode,
}

export const EventRegistrationContextProvider: React.FC<Props> = ({ children }) => {
    const location = useLocation();
    const [selectedRegistrantIndex, setSelectedRegistrantIndex] = useState<number>(0);
    const [isEditing, setIsEditing] = useState(false);
    const isEventRegistration = !!matchPath('/event-registration/:eventId', location.pathname);

    useEffect(() => {
        if (!isEventRegistration) {
            setIsEditing(false);
            setSelectedRegistrantIndex(0);
        }
    }, [isEventRegistration]);

    const {
        expandedIds,
        setExpandedIds,
        directStateSetExpandedIds,
        toggleExpandedId,
        getIsIdExpanded,
        getIsIdExpandedDelayed,
    } = useCollapseGroup({
        sessionStorageKey: 'registrationExpandedIds',
    });

    return (
        <EventRegistrationContext.Provider
            value={{
                expandedIds,
                setExpandedIds,
                directStateSetExpandedIds,
                toggleExpandedId,
                getIsIdExpanded,
                getIsIdExpandedDelayed,
                selectedRegistrantIndex,
                setSelectedRegistrantIndex,
                isEditing,
                setIsEditing,
            }}
        >
            {children}
        </EventRegistrationContext.Provider>
    );
}

export const useEventRegistrationContext = () => useContext(EventRegistrationContext);